import ViewSupportUserPage from "../../../component/users/support/ViewSupportUser"

 
 
function ViewSupportUser() {
  return (
    <div className="page-body"><ViewSupportUserPage/></div>
  )
}

export default ViewSupportUser